import styled from "@emotion/styled";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { COLOR_GREY_5 } from "shared/theme/colors";
import Box from "@mui/material/Box";

const Cell = styled(TableCell)`
    border-right: 1px solid ${COLOR_GREY_5};
    border-bottom: none;

    &:last-child {
        border-right: none;
    }

    min-width: 130px;
`

export const StyledTableCell = styled(Cell)`
    padding: 8px;
    vertical-align: top;
`;

export const StyledTableContentCell = styled(StyledTableCell)`
    min-width: 260px;
`;

export const StyledTableHeadCell = styled(Cell)`
    padding: 12px;

    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 21px */
`;

export const StyledTableHeadContentCell = styled(StyledTableHeadCell)`
    min-width: 260px;
`;

export const StyledTableRow = styled(TableRow)`
    border-bottom: 1px solid ${COLOR_GREY_5};

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledTableHead = styled(TableHead)`
    border-bottom: 1px solid ${COLOR_GREY_5};
`;

export const StyledTableWrapper = styled(Box)`
    overflow: hidden;
    overflow-x: scroll;
`
